import inputsConfig from "./inputConfig";

export default {
  accordion: false,
  items: [
    {
      name: "Challenger's email",
      required: true,
      fields: inputsConfig.email,
    },
    {
      name: "Select an action for this challenger",
      required: true,
      fields: inputsConfig.action_type,
    },
  ],
};

export const forceChallengerItem = {
  name: "Select company team to attach to",
  required: true,
  fields: inputsConfig.company_team_id,
};
